'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoBackspaceOutline = function IoBackspaceOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm32.3 25.9c0.1 0.2 0.2 0.4 0.2 0.5s-0.1 0.3-0.2 0.5l-1.7 1.7c-0.1 0.2-0.3 0.2-0.4 0.2s-0.4 0-0.5-0.2l-5.9-6-6 6c-0.1 0.2-0.3 0.2-0.5 0.2s-0.3 0-0.4-0.2l-1.7-1.7c-0.1-0.2-0.2-0.3-0.2-0.5s0.1-0.3 0.2-0.5l6-5.9-6-5.9c-0.3-0.3-0.3-0.7 0-1l1.7-1.7c0.1-0.2 0.3-0.2 0.4-0.2s0.4 0 0.5 0.2l5.9 5.9 6-5.9c0.1-0.2 0.3-0.2 0.5-0.2s0.3 0 0.4 0.2l1.7 1.7c0.3 0.3 0.3 0.7 0 1l-6 5.9z m6.7-18.6c0.7 0.7 1 1.6 1 2.6v20c0 2.1-1.6 3.9-3.6 3.9h-23.3c-1 0-1.9-0.3-2.6-0.8-0.7-0.3-1.3-0.8-1.8-1.5l-0.1-0.1-8.6-11.4 8.6-11.6c1.1-1.4 2.7-2.2 4.5-2.2h23.3c1 0 1.9 0.4 2.6 1.1z m-1.5 22.6v-20c0-0.7-0.4-1.1-1.1-1.1h-23.3c-0.8 0-1.7 0.2-2.5 1.2l-7.5 10 7.5 10c0.6 0.8 1.4 1.3 2.5 1.3h23.3c0.7 0 1.1-0.7 1.1-1.4z' })
        )
    );
};

exports.default = IoBackspaceOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/backspace-outline.js
// module id = 2438
// module chunks = 168707334958949